<po-page-change-password [p-hide-current-password]="true" p-logo="logo2.png" p-secondary-logo="logo2.png"
    [p-url-new-password]="serviceApi" [p-requirements]="poPageChangePasswordRequirement">
</po-page-change-password>
